module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 添加 ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.deliveryList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "deliveryTitle",
      "label": "分拨点",
      "align": "center",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "详细地址",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.contact) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.tel) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联账户名",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), [_c('el-button', {
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deleteData(scope.row.addressId)
            }
          }
        }, [_vm._v("删除")])]]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.editDialog.show,
      "title": _vm.editDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "520px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editDialog.data,
      "rules": _vm.editDialog.form_rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [(_vm.editDialog.step == 1 || _vm.editDialog.step == 3) ? _c('div', {
    staticClass: "first"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contact",
      "label": "负责人姓名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人姓名"
    },
    model: {
      value: (_vm.editDialog.data.contact),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "contact", $$v)
      },
      expression: "editDialog.data.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tel",
      "label": "负责人电话："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人电话",
      "maxlength": "20"
    },
    model: {
      value: (_vm.editDialog.data.tel),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "tel", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryTitle",
      "label": "分拨点："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入分拨地址",
      "minlength": "128"
    },
    model: {
      value: (_vm.editDialog.data.deliveryTitle),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "deliveryTitle", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.deliveryTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": "详细地址："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入分拨点详细地址",
      "minlength": "300"
    },
    model: {
      value: (_vm.editDialog.data.address),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "contactPhoto",
      "label": "负责人照片："
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false,
      "http-request": _vm.handleLicenseImgFile,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.editDialog.data.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.process.env.IMG_URL + _vm.editDialog.data.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 3) ? _c('div', {
    staticClass: "second"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "userName",
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.editDialog.data.userName),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "userName", $$v)
      },
      expression: "editDialog.data.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "用户密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入用户密码",
      "maxlength": "32"
    },
    model: {
      value: (_vm.editDialog.data.password),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.password"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 2) ? _c('div', {
    staticClass: "second"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "userName",
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.editDialog.data.userName),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "userName", $$v)
      },
      expression: "editDialog.data.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "用户密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户密码",
      "maxlength": "32"
    },
    model: {
      value: (_vm.editDialog.data.password),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.password"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.editDialog.step == 1 || _vm.editDialog.data.addressId) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.show = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 1 && !_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog.step = 2
      }
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 2 && !_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog.step = 1
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 2 && !_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提 交")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de14c96e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/distribution/list.vue
// module id = 1265
// module chunks = 2